module.exports = __webpack_public_path__ + "static/media/box.638e008a.svg";